import { AbstractControl, AbstractControlOptions, AsyncValidatorFn, UntypedFormGroup, ValidatorFn } from '@angular/forms';
import { PropertyNameMapper } from '@app/shared/forms/property-mapper';
import * as R from 'ramda';

/**
 * Extension of Angular's FormGroup that allow form control names to be mapped to Domain property names.
 * ex. ACL permissions or Valdr validation schema.
 */
export class PcsFormGroup extends UntypedFormGroup {
  private propertyNameMapper: PropertyNameMapper;

  private get mapper() {
    if (!this.propertyNameMapper) {
      throw new Error('Property name mapper is not defined');
    }

    return this.propertyNameMapper;
  }

  static withPropertyNameMapper(
    controls: { [key: string]: AbstractControl },
    propertyNameMapper: PropertyNameMapper,
    validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null,
    asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null
  ) {
    const formGroup = new PcsFormGroup(controls, validatorOrOpts, asyncValidator);
    formGroup.setPropertyNameMapper(propertyNameMapper);
    return formGroup;
  }

  getPropertyName(formControlName: string): string {
    return this.mapper.getPropertyName(formControlName);
  }

  setPropertyNameMapper(propertyNameMapper: PropertyNameMapper) {
    this.propertyNameMapper = propertyNameMapper;
  }

  getEntityName(): string {
    return this.mapper.getEntityName();
  }
}

export const isPcsFormGroup = R.is(PcsFormGroup);
